import { IItemSection } from './itemSection';
import { IEvent, Event } from './event';
import { SectionCreatorFactory } from './sections/sectionCreatorFactory';
import { Product } from '@/store/modules/product';

export interface ISectionCreator {
    onSectionsChanged: IEvent<IItemSection[]>;
    initialize(scenePreview: any): void;
}

class SectionCreator implements ISectionCreator {
    get onSectionsChanged() { return this._onSectionChanged.expose(); }

    private _onSectionChanged = new Event<IItemSection[]>();
    private sectionCreatorFactory!: SectionCreatorFactory;

    public initialize(scenePreview: any): void {
        this.sectionCreatorFactory = new SectionCreatorFactory(scenePreview);
    }

    public update(product: Product) {
        const sectionCreatorStrategy = this.sectionCreatorFactory.get(product);
        const sections = sectionCreatorStrategy.create(product);
        this._onSectionChanged.trigger(sections);
    }
}

export const sectionCreator = new SectionCreator();
